<p-toast />
<hr class="mt-0" />
<form [formGroup]="form" (submit)="onSave()" class="p-fluid w-full">
  <div class="flex flex-column gap-3 mb-4">
    <!-- Practice Field: hidden when the user is confined to their own practice,
         because it is already preselected and cannot be changed. -->
    <div class="field grid" *ngIf="!isPracticeScoped">
      <label emRequiredMark for="practice" class="col-12 md:col-4 font-medium">
        {{ 'layout.configurations.evaluation.salaryRanges.rangeForm.practice' | translate }}
      </label>
      <div class="col-12 md:col-8">
        <p-dropdown
          formControlName="practice"
          inputId="practice"
          [options]="practices"
          [filter]="true"
          appendTo="body"
          class="w-full"
          (onChange)="onPracticeChange()"
          [ngClass]="{ 'p-invalid': isInvalid('practice').invalid }" />
        <small *ngIf="isInvalid('practice').invalid" class="text-red-600">
          {{ isInvalid('practice').message | translate }}
        </small>
      </div>
    </div>

    <!-- Category Field -->
    <div class="field grid">
      <label emRequiredMark for="categoryShortLabel" class="col-12 md:col-4 font-medium">
        {{ 'layout.configurations.evaluation.salaryRanges.rangeForm.category' | translate }}
      </label>
      <div class="col-12 md:col-8">
        <p-dropdown
          formControlName="categoryShortLabel"
          inputId="categoryShortLabel"
          [options]="categoryOptions"
          optionLabel="label"
          optionValue="value"
          [filter]="true"
          filterBy="label"
          [showClear]="true"
          [disabled]="!categoryOptions.length"
          [placeholder]="
            (categoryOptions.length
              ? 'layout.configurations.evaluation.salaryRanges.rangeForm.categoryPlaceholder'
              : 'layout.configurations.evaluation.salaryRanges.rangeForm.noCategories'
            ) | translate
          "
          appendTo="body"
          class="w-full"
          [ngClass]="{ 'p-invalid': isInvalid('categoryShortLabel').invalid }" />
        <small *ngIf="isInvalid('categoryShortLabel').invalid" class="text-red-600">
          {{ isInvalid('categoryShortLabel').message | translate }}
        </small>
      </div>
    </div>

    <!-- Low Field -->
    <div class="field grid">
      <label for="lowSalary" class="col-12 md:col-4 font-medium">
        {{ 'layout.configurations.evaluation.salaryRanges.rangeForm.low' | translate }} (DH)
      </label>
      <div class="col-12 md:col-8">
        <p-inputNumber
          (onFocus)="selectAllOnFocus($event)"
          formControlName="lowSalary"
          inputId="lowSalary"
          [min]="0"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [allowEmpty]="true"
          mode="decimal"
          [showButtons]="false"
          class="w-full"
          [ngClass]="{ 'p-invalid': isInvalid('lowSalary').invalid }" />
        <small *ngIf="isInvalid('lowSalary').invalid" class="text-red-600">
          {{ isInvalid('lowSalary').message | translate }}
        </small>
      </div>
    </div>

    <!-- Medium Field -->
    <div class="field grid">
      <label for="mediumSalary" class="col-12 md:col-4 font-medium">
        {{ 'layout.configurations.evaluation.salaryRanges.rangeForm.medium' | translate }} (DH)
      </label>
      <div class="col-12 md:col-8">
        <p-inputNumber
          (onFocus)="selectAllOnFocus($event)"
          formControlName="mediumSalary"
          inputId="mediumSalary"
          [min]="0"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [allowEmpty]="true"
          mode="decimal"
          [showButtons]="false"
          class="w-full"
          [ngClass]="{ 'p-invalid': isInvalid('mediumSalary').invalid }" />
        <small *ngIf="isInvalid('mediumSalary').invalid" class="text-red-600">
          {{ isInvalid('mediumSalary').message | translate }}
        </small>
      </div>
    </div>

    <!-- High Field -->
    <div class="field grid">
      <label for="highSalary" class="col-12 md:col-4 font-medium">
        {{ 'layout.configurations.evaluation.salaryRanges.rangeForm.high' | translate }} (DH)
      </label>
      <div class="col-12 md:col-8">
        <p-inputNumber
          (onFocus)="selectAllOnFocus($event)"
          formControlName="highSalary"
          inputId="highSalary"
          [min]="0"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [allowEmpty]="true"
          mode="decimal"
          [showButtons]="false"
          class="w-full"
          [ngClass]="{ 'p-invalid': isInvalid('highSalary').invalid }" />
        <small *ngIf="isInvalid('highSalary').invalid" class="text-red-600">
          {{ isInvalid('highSalary').message | translate }}
        </small>
      </div>
    </div>

    <!-- Exceed Field -->
    <div class="field grid">
      <label for="exceedSalary" class="col-12 md:col-4 font-medium">
        {{ 'layout.configurations.evaluation.salaryRanges.rangeForm.exceed' | translate }} (DH)
      </label>
      <div class="col-12 md:col-8">
        <p-inputNumber
          (onFocus)="selectAllOnFocus($event)"
          formControlName="exceedSalary"
          inputId="exceedSalary"
          [min]="0"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [allowEmpty]="true"
          mode="decimal"
          [showButtons]="false"
          class="w-full"
          [ngClass]="{ 'p-invalid': isInvalid('exceedSalary').invalid }" />
        <small *ngIf="isInvalid('exceedSalary').invalid" class="text-red-600">
          {{ isInvalid('exceedSalary').message | translate }}
        </small>
      </div>
    </div>
  </div>

  <hr />
  <div class="flex justify-content-end mb-4">
    <p-button
      type="submit"
      icon="pi pi-check"
      [label]="'layout.configurations.evaluation.salaryRanges.rangeForm.save' | translate"></p-button>
  </div>
</form>
